<div class="antique-card h-100 position-relative d-flex flex-column" *ngIf="item">
  <div class="card-img-wrapper" [style.background-image]="photo ? 'url(' + photo + ')' : 'url(/static/assets/img/header-bg.png)'">
    <div class="card-status-badge">
      <span *ngIf="!item.selling" class="badge-exhibition">
        <span class="material-symbols-outlined" style="font-size: 13px;">museum</span>
        Collection
      </span>
      <span *ngIf="item.selling" class="badge-marketplace">
        <span class="material-symbols-outlined" style="font-size: 13px;">storefront</span>
        Acquisition
      </span>
    </div>
  </div>

  <div class="p-3 d-flex flex-column flex-grow-1 justify-content-between">
    <div>
      <div class="d-flex align-items-center justify-content-between text-muted mb-1" style="font-size: 0.78rem;">
        <span>{{ item.category || 'Antique' }}</span>
        <span *ngIf="item.culture">{{ item.culture }}</span>
      </div>
      <h6 class="brand-font mb-1 text-truncate" [title]="item.title">{{ item.title }}</h6>
      <p class="text-muted small text-truncate mb-2" *ngIf="item.subtitle">{{ item.subtitle }}</p>
    </div>
    
    <div class="d-flex align-items-center justify-content-between pt-2 border-top">
      <div>
        <span class="fw-bold" style="color: var(--antiqry-gold-dark); font-size: 1.05rem;" *ngIf="item.selling && item.price">
          {{ item.price | antiqryCurrency:item.currency:true }}
        </span>
        <span class="text-muted small fst-italic" *ngIf="!item.selling">
          Curated Piece
        </span>
      </div>
      <div class="d-flex align-items-center text-muted gap-1" style="font-size: 0.8rem;">
        <span>{{ item.likes || 0 }}</span>
        <span class="material-symbols-outlined" style="font-size: 16px;">thumb_up</span>
      </div>
    </div>
  </div>

  <a class="stretched-link" [routerLink]="['/items', item.id]"></a>
</div>
